import kaplay from "kaplay";
// import "kaplay/global"; // uncomment if you want to use without the k. prefix

kaplay({
    width: 400,
    height: 600,
    background: "#FFFFCC",
    scale: 1,
    canvas: document.getElementById("canvas"),
});

loadRoot("./"); // A good idea for Itch.io publishing later
const ship = loadSprite("ship", "sprites/exploring_ship.png");
const dragonFly = loadSprite("dragonFly", "sprites/dragon_fly.png");
const bullet = loadSprite("bullet", "sprites/bullet.png");

let running = true;

function getRandomInt(max) {
    let arr = new Uint32Array(1);
	window.crypto.getRandomValues(arr);
	let randomValue = arr[0] % max; 
    return randomValue;	
}


scene("main", () => {
    const initPlayerPosX = 200 - 32;
    const initPlayerPosY = 500;
    const pSpeed = 200;
    const bSpeed = 400;
    let eSpeed = 300;
    const pSize = 32;
    const player = add([anchor("center"), sprite(ship), pos(initPlayerPosX, initPlayerPosY), area(), health(3), scale(4), rotate(-90), z(8), "player"]);
    const score = add([
        pos((center().x - center().x * 0.85), 42), 
        text("Score: 0"),
        color(BLUE),
        scale(0.75),
        { value: 0 },
        ]);
    const life = add([text("Life : 3"), pos((center().x + center().x * 0.25), 42), color(GREEN), scale(0.75), {value: 3}]);

    const particleHandler = add([
        timer(),
    ])

    particleHandler.loop(0.1, () => {
            shipParticles(player);
            get("bullet").forEach((bullet) => {
               bulletParticles(bullet); 
            });
            get("enemy").forEach((enemy) => {
                enemyParticle(enemy);
            });
        });


    const pRightMvt = onKeyDown("right", () => {
        if (player.pos.x + 16 < 400) {
            player.move(pSpeed, 0);
        }
    });

    const pLeftMvt = onKeyDown("left", () => {
        if (player.pos.x - 16 > 0) {
            player.move(-pSpeed, 0);
        }
    });

    const pUpMvt = onKeyDown("up", () => {
        if (player.pos.y - 16 > 0) {
            player.move(0, -pSpeed);
        }
    });
    const pDownMvt = onKeyDown("down", () => {
        if (player.pos.y + 16 < 600) {
            player.move(0, pSpeed);
        }
    });;

    const pShoot = onKeyPress("space", () => {
        add(createBullet());
    });
    

    const fixedUpdate = onFixedUpdate(() => {
        //shipParticles(player);
        
    });

    const mvBullets = onFixedUpdate("bullet", (bullet) => {
        bullet.move(0, -bSpeed);
        if (bullet.pos.y < -20) {
            bullet.destroy();
        }
        //bulletParticles(bullet);
    });

    const mvEnemies = onFixedUpdate("enemy", (enemy) => {
        enemy.move(0, eSpeed);
        if (enemy.pos.y > 650) {
            enemy.destroy();
        }
        eSpeed += 0.2;
    });

    const checkColBulEne = onCollide("bullet", "enemy", (bullet, enemy) => {
        explosion(bullet);
        bullet.destroy();
        enemy.destroy();
        score.value += 100;
        score.text = "Score: " + score.value;
    });

    const checkColPlayEne = player.onCollide("enemy", (enemy) => {
        player.hurt(1);
        enemy.destroy();
        explosion(player);
        life.value = player.hp();
        life.text = "Life : " + life.value;
        switch(life.value) {
            case 3 :
                life.color = GREEN;
                break;
            case 2 :
                life.color = rgb(255, 165, 0);
                break;
            case 1 :
                life.color = RED;
                break;
            default :
                life.color = BLACK;
                break;
        }
    })

    player.on("death", () => {
        running = false;
        const gameOverTxt = add([text("Game Over"), pos(100, 250), color(RED)]);
        const restartTxt = add([text("Press 'F5' to restart"), pos(center().x * 0.15, 350), color(BLACK), scale(0.75)]);
        // restartTxt.move((-restartTxt.width * 0.25), 0);
        // Toute cette partie là devrait être gérer par un système organisé en différentes scènes
        pRightMvt.cancel();
        pLeftMvt.cancel();
        pUpMvt.cancel();
        pDownMvt.cancel();
        pShoot.cancel();
        mvBullets.cancel();
        mvEnemies.cancel();
        checkColBulEne.cancel();
        checkColPlayEne.cancel();
        fixedUpdate.cancel();
        particleHandler.unuse("timer");
    })

    onKeyPress("backspace", () => {
        running = !running;
        generateEnemies();
        debug.log(running);
    });

    generateEnemies();
});

function createBullet() {
    const playerPos = get("player")[0].pos;
    return [scale(1.2), anchor("center"), sprite(bullet), pos(playerPos.x, playerPos.y - 16), z(5), area(), "bullet"];
}

function createEnemy() {
    const initEnemyPos = vec2(getRandomInt(200)+100, -40);
    return [sprite(dragonFly), scale(4), anchor("center"), rotate(90), pos(initEnemyPos), z(10), area(), "enemy"];
}


function generateEnemies() {
    
    if (running) {
        wait(0.63, () => {
                add(createEnemy());
                generateEnemies();
            })    
    }
}

function bulletParticles(bullet) {
    let particleEmitter = add([
        pos(bullet.pos.x, bullet.pos.y),
        particles(
            {
                max: 5, // the max amount of particles generated from this emitter at one time
                lifeTime: [0, 1], // how long the particles last before being destroyed
                speed: [20, 50], // how fast the particles are moving
                acceleration: [vec2(0, 5), vec2(0, 10)], // changes the speed of the particle over its lifetime
                damping: [0, 0], // slows down the particle over its lifetime
                angle: [0, 360], // the rotation of each particle
                angularVelocity: [0, 5], // how fast each particle should be rotating
                scales: [0.6, 0.0], // how large the particle is over its lifetime
                colors: [GREEN, YELLOW, WHITE], // the color of the particle over its lifetime
                opacities: [1.0, 0.0], // the opacity of the particle over its lifetime
            },
            {
                //shape: new Rect(vec2(0), 32, 32), // the area where particles should be emitted from (can be empty)
                lifetime: 0.5, // how long the emitter should last
                rate: 5, // the rate at which particles are emitted
                direction: 90, // the direction where particles should be traveling
                spread: 10, // variance in the direction where particles should be traveling
            },
        ),
    ]);

    // .onEnd is called when the emitter's lifetime (in this example 5 seconds), has expired.
    particleEmitter.onEnd(() => {
        destroy(particleEmitter);
    });
    
    // Emit Particles at runtime
    particleEmitter.emit(2);
}


function shipParticles(player) {
    let particleEmitter = add([
            pos(player.pos.x, player.pos.y + player.height * 2),
            particles(
                {
                    max: 5, // the max amount of particles generated from this emitter at one time
                    lifeTime: [1, 2], // how long the particles last before being destroyed
                    speed: [200, 400], // how fast the particles are moving
                    acceleration: [vec2(0, 5), vec2(0, 10)], // changes the speed of the particle over its lifetime
                    damping: [0, 0.5], // slows down the particle over its lifetime
                    angle: [0, 360], // the rotation of each particle
                    angularVelocity: [0, 5], // how fast each particle should be rotating
                    scales: [1.0, 0.5, 0.0], // how large the particle is over its lifetime
                    colors: [GREEN, WHITE], // the color of the particle over its lifetime
                    opacities: [1.0, 0.0], // the opacity of the particle over its lifetime
                },
                {
                    //shape: new Rect(vec2(0), 32, 32), // the area where particles should be emitted from (can be empty)
                    lifetime: 5, // how long the emitter should last
                    rate: 5, // the rate at which particles are emitted
                    direction: 90, // the direction where particles should be traveling
                    spread: 30, // variance in the direction where particles should be traveling
                },
            ),
        ]);

        // .onEnd is called when the emitter's lifetime (in this example 5 seconds), has expired.
        particleEmitter.onEnd(() => {
            destroy(particleEmitter);
        });
        
        // Emit Particles at runtime
        particleEmitter.emit(5);
}

function enemyParticle(enemy) {
    let particleEmitter = add([
        pos(enemy.pos.x, enemy.pos.y + enemy.height * 2),
        particles(
            {
                max: 5, // the max amount of particles generated from this emitter at one time
                lifeTime: [0, 1], // how long the particles last before being destroyed
                speed: [100, 200], // how fast the particles are moving
                acceleration: [vec2(0, 1), vec2(0, 2)], // changes the speed of the particle over its lifetime
                damping: [0, 0.5], // slows down the particle over its lifetime
                angle: [0, 360], // the rotation of each particle
                angularVelocity: [0, 5], // how fast each particle should be rotating
                scales: [0.6, 0.0], // how large the particle is over its lifetime
                colors: [BLUE, CYAN, WHITE], // the color of the particle over its lifetime
                opacities: [1.0, 0.0], // the opacity of the particle over its lifetime
            },
            {
                //shape: new Rect(vec2(0), 32, 32), // the area where particles should be emitted from (can be empty)
                lifetime: 0.5, // how long the emitter should last
                rate: 5, // the rate at which particles are emitted
                direction: 90, // the direction where particles should be traveling
                spread: 60, // variance in the direction where particles should be traveling
            },
        ),
    ]);

    // .onEnd is called when the emitter's lifetime (in this example 5 seconds), has expired.
    particleEmitter.onEnd(() => {
        destroy(particleEmitter);
    });
    
    // Emit Particles at runtime
    particleEmitter.emit(2);
}

function explosion(entity) {
    // le systeme de particule se fait en 2 temps : Une partie de création du système, et une autre d'émition des particules
    let particleEmitter = add([
            pos(entity.pos.x, entity.pos.y - entity.height * 3),
            particles(
                {
                    max: 20, // the max amount of particles generated from this emitter at one time
                    lifeTime: [2, 3], // how long the particles last before being destroyed
                    speed: [50, 100], // how fast the particles are moving
                    acceleration: [vec2(0), vec2(0, -5)], // changes the speed of the particle over its lifetime
                    damping: [0, 0.5], // slows down the particle over its lifetime
                    angle: [0, 360], // the rotation of each particle
                    angularVelocity: [0, 100], // how fast each particle should be rotating
                    scales: [1.0, 0.5, 0.0], // how large the particle is over its lifetime
                    colors: [YELLOW, RED], // the color of the particle over its lifetime
                    opacities: [1.0, 0.0], // the opacity of the particle over its lifetime
                },
                {
                    //shape: new Rect(vec2(0), 32, 32), // the area where particles should be emitted from (can be empty)
                    lifetime: 5, // how long the emitter should last
                    rate: 5, // the rate at which particles are emitted
                    direction: 0, // the direction where particles should be traveling
                    spread: 360, // variance in the direction where particles should be traveling
                },
            ),
        ]);
        // .onEnd is called when the emitter's lifetime (in this example 5 seconds), has expired.
        particleEmitter.onEnd(() => {
            destroy(particleEmitter);
        });

        // Emit Particles at runtime
        particleEmitter.emit(15);
}


go("main");